
/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Storage Shelf Mst Interface
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/
import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface ItemStorageShelfParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface ItemStorageShelf {
  id?:number;
  code:string;
  name:string;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  createdIP:string;
  updatedIP:string;
    
  parameters?: ItemStorageShelfParameter[];
  links?: any;
}

export abstract class ItemStorageShelfData { 
  abstract list(url: string): Observable<ItemStorageShelf[]>;
  abstract create(url: string,data: ItemStorageShelf): Observable<any>;
  abstract update(url: string,data: ItemStorageShelf): Observable<any>;
  abstract delete(url: string): Observable<any>;
}